import React, { useState } from 'react';
import { useAppDispatch } from '../../store';
import { showModal } from '../../store/actions/modalActions';
import { useTranslation } from 'react-i18next';
import FileUploader from '../shared/TailwindComponents/FileUploader';
import Button from '../shared/TailwindComponents/Button';
import { importClients } from '../../store/actions/ClientActions';

const ImportClientsModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [files, setFiles] = useState<File[]>([]);
  const [isImporting, setIsImporting] = useState(false);

  const handleImport = async () => {
    if (files.length === 0) {
      dispatch(
        showModal({
          type: 'error',
          message: t('Please select at least one file.'),
          showModal: true,
        })
      );
      return;
    }

    setIsImporting(true);
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));

    try {
      await dispatch(importClients(formData));
      onClose();
    } catch (error) {
      if(!error) return
      setIsImporting(false);
    }
  };

  return (
    <div className="space-y-4 w-[500px]">
      <div className='px-4'>
      <FileUploader files={files} onFilesChange={setFiles} />
      </div>
    
      <div className="flex justify-end space-x-2 px-4 border-1 border-t border-gray-300 pt-6 mt-6">
        <Button onClick={onClose} variant="neutral" size="small" disabled={isImporting}>
          {t('Cancel')}
        </Button>
        <Button onClick={handleImport} variant="primary" size="small" disabled={isImporting}>
          {isImporting ? t('Importing...') : t('Import')}
        </Button>
      </div>
    </div>
  );
};

export default ImportClientsModal;